import React, { useEffect, useState } from "react";
import Intercom from '@intercom/messenger-js-sdk';
import styled from "styled-components";
import BreadCrumb from "../components/Booking/BreadCrumb";
import CartBanner from "../components/MyCart/BannerCart";
import MyCartFooter from "../components/MyCart/Footer";
import { Colors } from "../ColorConstants";
import {
  checkoutCart,
  checkoutTicket,
  getCart,
  verifyTransaction,
} from "../services/cartServices";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  BackArrow,
  BackButton,
  RadioSelected,
  RadioUnSelected,
} from "../assets/icons";
import {
  AppleLogo,
  ApplePay,
  cartBg,
  Gpay,
  GPayLogo,
  MasterCard,
  MasterLogo,
  Visa2,
  VisaLogo,
} from "../assets/images";
import { PAYMENT_TYPE } from "../constants";
import Button from "../components/Buttons";
import { Text } from "../TextConstants";
import Loader from "../components/PaymentLoader";
import { getUserData } from "../services/userServices";
import { toast } from "react-toastify";
import Footer, { FooterMobile } from "../components/Footer";
import CustomLoader from "../components/Loader";
import { trackFBEvent } from "../analytics";
import { EVENT } from "../analytics/constants";
import ReactGA from "react-ga4";

const Checkout = () => {
  const [winObj, setWindow] = useState({});
  const [cart, setCart] = useState({});
  const [profile, setProfile] = useState({});
  const [insertId, setInsertId] = useState("");
  const [urlId, setUrlId] = useState("");
  let refreshIntervalId;
  const [items, setItems] = useState([]);
  const [type, setType] = useState(PAYMENT_TYPE.WALLET);
  let [searchParams] = useSearchParams();
  let promo = searchParams.get("promo");
  const navigate = useNavigate();
  let userType = localStorage.getItem("type");
  const [loading, setLoading] = useState(false);
  const userAgent = navigator.userAgent;
  const isMobile = /Mobi|Android/i.test(userAgent);

  useEffect(() => {
    let usrType = localStorage.getItem("type");
    fetchCart();
    if (!["guest"].includes(usrType)) {
      fetchProfile();
    } else {
      setType(PAYMENT_TYPE.ONLINE);
    }
  }, []);

  useEffect(() => {
    if (urlId || insertId) {
      refreshIntervalId = setInterval(fetchTicket, 10000);
    }
  }, [urlId, insertId]);

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "Checkout Page" });
  }, []);

  const fetchProfile = async () => {
    try {
      let res = await getUserData();
      setType(
        res?.data?.data?.userType === "guest"
          ? PAYMENT_TYPE.ONLINE
          : PAYMENT_TYPE.WALLET
      );
      setProfile(res?.data?.data);
      Intercom({
        app_id: 'tcacfciz',
        name: res?.data?.data.name,
        email: res?.data?.data.email,
        phone: res?.data?.data.phone,
        user_id: res?.data?.data.userCode
      });
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTicket = async () => {
    if (type === PAYMENT_TYPE.WALLET) {
      try {
        let res = await checkoutTicket(insertId);
        if (res?.data?.data?.paymentStatus === "Success") {
          clearInterval(refreshIntervalId);
          setInsertId("");
          localStorage.removeItem("cartId");
          navigate(`/app/success?insertId=${insertId}`);
        }
      } catch (err) {
        toast.error(err.message);
      }
    } else {
      try {
        let res = await verifyTransaction(urlId);
        if (res?.data?.data?.resultObj?.status === "paid") {
          clearInterval(refreshIntervalId);
          setInsertId("");
          setUrlId("");
          localStorage.removeItem("cartId");
          if (type === PAYMENT_TYPE.ONLINE && winObj) {
            winObj.close();
          }
          navigate(`/app/success?insertId=${insertId}`);
        } else if (res?.data?.data?.resultObj?.status === "new") {
          console.log("Processing...");
        } else {
          clearInterval(refreshIntervalId);
          setInsertId("");
          setUrlId("");
          localStorage.removeItem("cartId");
          if (type === PAYMENT_TYPE.ONLINE && winObj) {
            winObj.close();
          }
          toast.error("Payment failed, Please try again!");
        }
      } catch (err) {
        toast.error(err.message);
      }
    }
  };

  const fetchCart = async () => {
    localStorage.removeItem("shouldContinue");
    try {
      let res = await getCart(promo || "");
      if (res?.data?.data?.items) {
        setCart(res?.data?.data);
        setItems(res?.data?.data?.items);
      } else {
        navigate(`/auth/home`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getAmount = (prod) => {
    if (cart?.outletShortName === "aqua_zone") {
      const sum = prod.reduce((acc, item) => {
        return (
          acc +
          item.slots.reduce(
            (innerAcc, slot) => innerAcc + slot.unitPrice * slot.qty,
            0
          )
        );
      }, 0);
      return sum;
    } else {
      let result = prod?.reduce(function (acc, obj) {
        return acc + obj.unitPrice * obj.qty;
      }, 0);
      return result;
    }
  };

  const handlePayNow = async () => {
    const typeUser = localStorage.getItem("type");
    const isUAT =
      window.location.hostname.includes("uat") ||
      window.location.hostname.includes("localhost");
    setLoading(true);
    try {
      let res = await checkoutCart(cart?._id, { type });
      trackFBEvent(EVENT.CHECKOUT, { cartId: cart?._id, type });
      setInsertId(res?.data?.data?.insertId);
      setUrlId(res?.data?.data?.redirectUrl?.split("pay/")[1]);
      if (type === PAYMENT_TYPE.ONLINE) {
        // if (isMobile) {
        window.location.href = res?.data?.data?.redirectUrl;
        // } else {
        //   let newWindow = window.open(res?.data?.data?.redirectUrl, "", "");
        //   setWindow(newWindow);
        // }
      }
      trackFBEvent(EVENT.PAYMENT_SUCCESS, { status: true });
      if (!isUAT) {
        if (cart?.validPromo) {
          ReactGA.event({
            category: "Custom Events",
            action: `${cart?.outletName} Payment Success with Promo ${cart?.promo}`,
            label: `Payment Success ${cart?.outletName} with Promo ${cart?.promo} for ${typeUser} `,
          });
        } else {
          ReactGA.event({
            category: "Custom Events",
            action: `${cart?.outletName} Payment Success`,
            label: `Payment Success ${cart?.outletName} for ${typeUser} `,
          });
        }
      }
    } catch (err) {
      toast.error(err?.message, { hideProgressBar: true });
      trackFBEvent(EVENT.PAYMENT_FAILURE, { status: true });
      if (!isUAT) {
        if (cart?.validPromo) {
          ReactGA.event({
            category: "Custom Events",
            action: `${cart?.outletName} Payment Failure with Promo ${cart?.promo}}`,
            label: `Payment Failure ${cart?.outletName} with Promo ${cart?.promo} for ${typeUser} `,
          });
        } else {
          ReactGA.event({
            category: "Custom Events",
            action: `${cart?.outletName} Payment Failure`,
            label: `Payment Failure ${cart?.outletName} for ${typeUser} `,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const getBreadCrumbData = () => {
    return [
      { label: "Home", path: `/auth/home` },
      {
        label: "Booking",
        path:
          cart?.outletShortName === "aqua_zone"
            ? `/app/aqua`
            : `/app/booking/${cart?.outletId}`,
      },
      {
        label: cart?.outletName,
        path:
          cart?.outletShortName === "aqua_zone"
            ? `/app/aqua`
            : `/app/booking/${cart?.outletId}`,
      },
      { label: "Cart", path: `/app/cart` },
      { label: "Payment Method", path: `/app/checkout` },
    ];
  };

  return (
    <>
      <BannerContainer>
        <img src={cartBg} />
        <Overlay>
          <div>
            <Logo src={require("../assets/images/lww_logo.png")} alt="logo" />
          </div>
          <div style={{ paddingTop: "1rem" }}></div>
        </Overlay>
      </BannerContainer>
      {/* {!promo?.includes("spin") && (
        <BackImageContainer onClick={() => navigate(`/app/cart`)}>
          <BackImage src={BackButton} />
        </BackImageContainer>
      )} */}
      {insertId ? (
        <div
          style={{
            position: "absolute",
            top: 0,
            height: "100vh",
            width: "100vw",
            background: "#0261a3",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            boxSizing: "border-box",
            overflow: "hidden",
            flexDirection: "column",
            fontSize: "1.5rem",
            gap: "1rem",
          }}
        >
          <Loader />
          Payment is being processed
          <div style={{ fontSize: "1rem" }}>
            Please don't close/refresh the browser.
          </div>
        </div>
      ) : (
        <CheckoutContainer>
          {/* <CartBanner
            header="Payment Method"
            description="Entertainment Park"
          /> */}
          {/* <BreadCrumb
            items={getBreadCrumbData()}
            activeItem={"Payment Method"}
            isButton={false}
          /> */}
          <CheckoutSummary>
            <CheckoutSummaryContainer>
              <PaymentSelectionContainer>
                <PaymentSelectionHeader>Payment Method</PaymentSelectionHeader>
                <PaymentSelectionDescription>
                  All transactions are secure and encrypted.
                </PaymentSelectionDescription>
                <PaymentOptionsContainer>
                  {!["guest"].includes(userType) && (
                    <>
                      <WalletPaymentContainer>
                        <PaymentOptionWrapper
                          onClick={() => setType(PAYMENT_TYPE.WALLET)}
                        >
                          <RadioButton>
                            {type === PAYMENT_TYPE.WALLET ? (
                              <img src={RadioSelected} />
                            ) : (
                              <img src={RadioUnSelected} />
                            )}
                          </RadioButton>
                          <RadioLabels>
                            <RadioLabel>Wallet</RadioLabel>
                            <RadioDescription>
                              Pay with cash upon delivery.
                            </RadioDescription>
                          </RadioLabels>
                        </PaymentOptionWrapper>
                        <WalletBalance>{profile?.balance} QAR</WalletBalance>
                      </WalletPaymentContainer>
                      <Divider />
                    </>
                  )}
                  <OnlinePaymentContainer>
                    <PaymentOptionWrapper
                      onClick={() => setType(PAYMENT_TYPE.ONLINE)}
                    >
                      <RadioButton>
                        {type === PAYMENT_TYPE.ONLINE ? (
                          <img src={RadioSelected} />
                        ) : (
                          <img src={RadioUnSelected} />
                        )}
                      </RadioButton>

                      <RadioLabels>
                        <PaymentOptionLogoContainer>
                          <RadioLabel>Online Payment</RadioLabel>
                          <OnlinePaymentOptionsLogoMobile>
                            <LogoImg src={Visa2} />
                            <LogoImg src={MasterCard} />
                            <LogoImg src={ApplePay} />
                            <LogoImg src={Gpay} />
                          </OnlinePaymentOptionsLogoMobile>
                        </PaymentOptionLogoContainer>

                        <RadioDescription>
                          We accept all major credit cards.
                        </RadioDescription>
                      </RadioLabels>
                    </PaymentOptionWrapper>
                    <OnlinePaymentOptionsLogo>
                      <img src={GPayLogo} />
                      <img src={AppleLogo} />
                      <img src={MasterLogo} />
                      <img src={VisaLogo} />
                    </OnlinePaymentOptionsLogo>
                  </OnlinePaymentContainer>
                </PaymentOptionsContainer>
                <ActionContainer>
                  <Button
                    label="Pay Now"
                    width="100%"
                    variant="filled"
                    onClick={handlePayNow}
                    fontSize="1.125rem"
                  />
                </ActionContainer>
              </PaymentSelectionContainer>
              <OrderSummaryContainer>
                <OrderSummaryHeaderMobile>
                  Order Summary
                </OrderSummaryHeaderMobile>
                <OrderSummaryBox>
                  <OrderSummaryHeader>Order Summary</OrderSummaryHeader>
                  {items?.map((item) => (
                    <OrderItem>
                      <OrderItemLabel>
                        <OrderItemName>{item?.name}</OrderItemName>
                        <OrderItemQuantity>
                          Ticket : <span>{item?.qty}</span>
                        </OrderItemQuantity>
                      </OrderItemLabel>
                      <OrderItemPrice>
                        {Text.qar} {item?.totalPrice}
                      </OrderItemPrice>
                    </OrderItem>
                  ))}
                  <OrderSubTotalContainer>
                    <SubTotalWrapper>
                      <OrderAmountLabel
                        style={{ fontWeight: "500", color: "black" }}
                      >
                        Subtotal <span>{`(${items?.length || 0} Items)`}</span>
                      </OrderAmountLabel>
                      <OrderAmountValue>
                        {Text.qar} {getAmount(items)}
                      </OrderAmountValue>
                    </SubTotalWrapper>
                    {Number(cart?.discountAmount) > 0 && (
                      <SubTotalWrapper>
                        <OrderAmountLabel style={{ fontWeight: "300" }}>
                          Savings
                        </OrderAmountLabel>
                        <OrderAmountValue>
                          -{Text.qar} {cart?.discountAmount}
                        </OrderAmountValue>
                      </SubTotalWrapper>
                    )}
                    <Divider2 />
                  </OrderSubTotalContainer>
                  {/* <div style={{}}></div> */}
                  <OrderTotalContainer>
                    <OrderAmountLabel
                      style={{
                        fontWeight: "700",
                        fontSize: "1.125rem",
                        color: Colors.aqua,
                      }}
                    >
                      Total
                    </OrderAmountLabel>
                    <OrderAmountValue
                      style={{
                        fontWeight: "700",
                        fontSize: "1.125rem",
                        color: Colors.aqua,
                      }}
                    >
                      {Text.qar} {cart?.finalAmount}
                    </OrderAmountValue>
                  </OrderTotalContainer>
                </OrderSummaryBox>
              </OrderSummaryContainer>
            </CheckoutSummaryContainer>
          </CheckoutSummary>
          {/* <FooterContainer>
            <Footer />
          </FooterContainer>
          <FooterMobile /> */}
          {loading ? <CustomLoader /> : <></>}
        </CheckoutContainer>
      )}
    </>
  );
};
const BackImageContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: flex;
    position: fixed;
    top: 2rem;
    margin: 0 0 0 0.5rem;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 0.5rem;
    z-index: 1000;
  }
  @media only screen and (min-width: 577px) {
    display: none;
  }
`;
const BackImage = styled.img`
  width: 0.6rem;
  height: 0.8rem;
  padding: 0.8rem;
  resize-mode: contain;
`;
const OrderAmountLabel = styled.div`
  font-weight: 600;
  font-size: 1.25rem;
  > span {
    font-weight: 400;
    color: ${Colors.arsenic};
    font-size: 1rem;
  }
  @media only screen and (max-width: 1024px) {
    font-weight: 500;
    font-size: 1rem;
  }
`;
const OrderAmountValue = styled.div`
  font-weight: 600;
  font-size: 1rem;
  color: ${Colors.arsenic};
`;
const SubTotalWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 1024px) {
    margin-top: 0.5rem;
  }
`;
const OrderTotalContainer = styled.div`
  padding: 0.5rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const OrderSubTotalContainer = styled.div`
  padding: 1rem 0;
  border-bottom: 1px solid #edeef2;
`;

const OrderItem = styled.div`
  padding: 1rem 0;
  border-bottom: 1px solid #edeef2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 1024px) {
    border-bottom: 1px solid ${Colors.lineBlack};
  }
`;
const OrderItemLabel = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;
const OrderItemName = styled.div`
  font-weight: 600;
  font-size: 0.875rem;
  color: ${Colors.arsenic};

  @media only screen and (max-width: 1024px) {
    font-weight: 500;
    font-size: 0.875rem;
    color: ${Colors.arsenic};
  }
`;
const OrderItemQuantity = styled.div`
  @media only screen and (max-width: 1024px) {
    font-weight: 500;
    font-size: 0.875rem;
    color: ${Colors.arsenic};
  }
  > span {
    color: #807d7e;
    @media only screen and (max-width: 1024px) {
      font-weight: 700;
      font-size: 0.875rem;
      color: ${Colors.approxGrey};
    }
  }
`;
const OrderItemPrice = styled.div`
  text-align: right;
  color: #807d7e;
  @media only screen and (max-width: 1024px) {
    font-weight: 600;
    font-size: 0.875rem;
    color: ${Colors.approxGrey};
  }
`;
const OrderSummaryHeaderMobile = styled.div`
  display: none;
  @media only screen and (max-width: 1024px) {
    display: block;
    font-size: 1.125rem;
    font-weight: 700;
    color: ${Colors.aqua};
    padding-bottom: 1rem;
  }
`;
const OrderSummaryHeader = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  color: ${Colors.arsenic};
  padding: 1rem 0;
  border-bottom: 1px solid #edeef2;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;
const ActionContainer = styled.div`
  padding: 2rem 0rem;
  width: 8rem;

  @media only screen and (max-width: 1024px) {
    display: flex;
    justify-content: center;
    padding: 1rem 0rem 1.5rem 0;
    margin: auto;
    width: 90%;
  }
`;

const OnlinePaymentOptionsLogo = styled.div`
  display: flex;
  gap: 1rem;
  margin-left: 2rem;
  margin-top: 1rem;
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;
const PaymentOptionLogoContainer = styled.div`
  @media only screen and (max-width: 1024px) {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // border: 1px solid red;
  }
`;

const OnlinePaymentOptionsLogoMobile = styled.div`
  display: none;

  @media only screen and (max-width: 1024px) {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-left: 3rem;
    flex-grow: 1;
  }
`;
const LogoImg = styled.img`
  @media only screen and (max-width: 1024px) {
    width: 30px;
    height: 25px;
    resize-mode: contain;
    // background-color: red
  }
  @media only screen and (max-width: 576px) {
    width: 2rem;
    height: 1.8rem;
    resize-mode: contain;
  }
`;

const OnlinePaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem 0;

  @media only screen and (max-width: 1024px) {
    padding: 1rem 0;
  }
`;
const WalletPaymentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
`;
const CheckoutContainer = styled.div``;
const WalletBalance = styled.div``;
const RadioButton = styled.div`
  @media only screen and (max-width: 1024px) {
    height: 1rem;
  }
`;
const PaymentOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
const RadioLabels = styled.div`
  color: ${Colors.arsenic};
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
`;
const RadioLabel = styled.div`
  font-weight: 600;
  font-size: 1rem;
`;
const RadioDescription = styled.div`
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;

const CheckoutSummary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5rem;
  @media only screen and (max-width: 1024px) {
    margin-top: 0rem;
  }
`;

const CheckoutSummaryContainer = styled.div`
  margin: 1rem 0 0 0;
  display: flex;
  width: 70vw;
  gap: 2rem;
  @media only screen and (max-width: 1024px) {
    width: 100%;
    padding: 0 1rem;
    flex-direction: column-reverse;
    box-sizing: border-box;
  }
`;

const PaymentSelectionHeader = styled.div`
  color: ${Colors.arsenic};
  font-size: 1.5rem;
  font-weight: 800;
  @media only screen and (max-width: 1024px) {
    color: ${Colors.secondaryBlack};
    font-weight: 700;
    font-size: 1.125rem;
  }
`;
const PaymentSelectionDescription = styled.div`
  color: ${Colors.arsenic};
  font-size: 1rem;
  font-weight: 400;
`;
const PaymentOptionsContainer = styled.div`
  width: 100%;
  border-radius: 0.75rem;
  background: ${Colors.lightWhiteSmoke};
  padding: 1rem 1rem;
  margin-top: 1rem;
  box-sizing: border-box;
  @media only screen and (max-width: 1024px) {
    background: none;
    margin-top: 0;
    // border: 1px solid red;
  }
`;

const PaymentSelectionContainer = styled.div`
  width: 65%;
  height: auto;
  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
`;
const OrderSummaryContainer = styled.div`
  width: 35%;
  height: auto;

  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
`;

const OrderSummaryBox = styled.div`
  width: 100%;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.05),
    -2px -2px 4px 0px rgba(0, 0, 0, 0.05);
  padding: 1rem;
  box-sizing: border-box;
  @media only screen and (max-width: 1024px) {
    background-color: ${Colors.whiteSmoke};
  }
`;
const Divider = styled.hr`
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;
const Divider2 = styled.hr`
  @media only screen and (max-width: 1024px) {
    color: #b8b8b8;
    margin-top: 1rem;
  }
`;

const FooterContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;

const BannerContainer = styled.div`
  height: 30rem;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  // @media only screen and (max-width: 1024px) {
  //   display: none;
  // }
`;
const Overlay = styled.div`
  position: absolute;
  // background-color: #0000005d;
  height: 10rem;
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: start;

  top: 0;
  @media only screen and (max-width: 768px) {
    width: 90%;
  }
`;

const Logo = styled.img`
  width: 22rem;
  resize: contain;

  @media only screen and (max-width: 768px) {
    width: 14rem;
  }
`;

export default Checkout;
